import React from 'react';
import {NavLink} from "react-router-dom";

const Login = ({profile, isLogin}) => {
    return (
        <>
            {isLogin ? <NavLink to={'/profile'} className="nav-item nav-link">{profile.first_name}</NavLink>
                : <NavLink to={'/login'} className="nav-item nav-link">Login</NavLink>}
        </>
    )
};
export default Login;